<template>
  <div class="gqjgtWrap">
    <div class="btnBox">
      <el-button :type="btnType==0?'primary':''" size="small" @click="getData('up')">控股股东</el-button>
      <el-button :type="btnType==1?'primary':''" size="small" @click="getData('down')">对外投资</el-button>
    </div>
    <div v-if="btnType==0" class="body"></div>
    <div v-if="btnType==1" class="body2"></div>
  </div>
</template>

<script>
import http from "../../static/common/api/axios";

export default {
  props: ["companyName"],
  data() {
    return {
      btnType: 0,
      // nom: "skt",
      nom: "nlpapi/KG",
      data: {
        name: "",
        tap: "节点",
        children: []
      }
    };
  },
  mounted() {
    this.getData("up");
  },
  methods: {
    getData(type) {
      this.btnType = type == "up" ? 0 : 1;
      http("post", this.nom + "/api", "json", {
        //控股股东
        companyname: this.companyName,
        // companyname: _this.companyName,
        direction: type,
        lable: "investor"
      }).then(res => {
        this.data = {
          name: this.companyName,
          tap: "节点",
          children: []
        };
        res.output.forEach((v, i) => {
          this.data.children.push(v);
        });
        setTimeout(() => {
          this.init(type);
        }, 400);
      });
    },
    init(types) {
      var type = types == "up" ? ".body" : ".body2";
      var child = document.querySelector(type);
      child.innerHTML = "";
      const d3 = require("d3");
      var i = 0,
        duration = 400,
        root;
      var margin = { top: 30, right: 20, bottom: 30, left: 800 },
        width = document.body.clientWidth,
        height = document.body.clientHeight,
        barHeight = 50,
        barSpace = 10,
        barWidth = width - margin.left - margin.right;

      // var diagonal = d3
      //   .linkHorizontal()
      //   .x(function(d) {
      //     return d.y;
      //   })
      //   .y(function(d) {
      //     return d.x;
      //   });
      var scale = 0.6;
      var svg = d3
        .select(type)
        .append("svg")
        //.attr("width", width) // + margin.left + margin.right)
        .attr("class", "svg")
        .attr("width", width)
        .attr("height", height)
        .on("dblclick.zoom", null);

      var container = svg
        .append("g")
        .attr(
          "transform",
          "translate(" + margin.left + "," + margin.top + ")scale(0.8)"
        )
        .attr("class", "container");
      function zoomFn() {
        var transform = d3.event.transform;
        container.attr(
          "transform",
          "translate(" +
            (transform.x + margin.left) +
            "," +
            (transform.y + margin.top) +
            ")scale(" +
            transform.k * 0.8 +
            ")"
        );
      }
      svg.call(
        d3
          .zoom()
          .scaleExtent([1 / 2, 4])
          .on("zoom", zoomFn)
      );

      // d3.json("flare.json", function(error, flare) {
      //   if (error) throw error;
      root = d3.hierarchy(this.data);
      root.x0 = 0;
      root.y0 = 0;
      update(root);
      // });

      function update(source) {
        //Compute the flattened node list.
        var nodes = root.descendants();
        var height = Math.max(
          1000,
          nodes.length * barHeight + margin.top + margin.bottom
        );

        d3.select("svg")
          .transition()
          .duration(duration)
          .attr("height", height);

        d3.select(self.frameElement)
          .transition()
          .duration(duration)
          .style("height", height + "px");

        //Compute the "layout". TODO https://github.com/d3/d3-hierarchy/issues/67
        var index = -1,
          count = 0;
        root.eachBefore(function(n) {
          count += barSpace;
          n.style = "node_" + n.depth;
          n.x = ++index * barHeight + count;
          n.y = n.depth * 20;
        });

        // Update the nodes…
        var node = container.selectAll(".node").data(nodes, function(d) {
          return d.id || (d.id = ++i);
        });

        let tooltip = d3
          .select("body")
          .append("div")
          .style("position", "absolute")
          .style("z-index", "10")
          .style("color", "#fff")
          .style("visibility", "hidden") // 是否可见（一开始设置为隐藏）
          .style("font-size", "12px")
          .style("font-weight", "bold");

        var nodeEnter = node
          .enter()
          .append("g")
          .attr("class", function(d) {
            return "node node_" + d.depth + " " + getClass(d);
          })
          .attr("transform", function(d) {
            return "translate(" + source.y0 + "," + source.x0 + ")";
          })
          .style("opacity", 0);

        //Enter any new nodes at the parent's previous position.
        nodeEnter
          .append("rect")
          .attr("y", -barHeight / 2)
          .attr("height", barHeight)
          .attr("width", "300")
          .style("stroke", "#333")
          .style("fill", "rgb(18, 107, 193)")
          .style("stroke-width", "0.5px");

        nodeEnter
          .append("rect")
          .attr("y", -barHeight / 2)
          .attr("height", barHeight)
          .attr("width", 3)
          .style("fill", "red");

        nodeEnter
          .append("text")
          .attr("dy", -3.5)
          .attr("dx", 40)
          .style("font-size", "18px")
          .style("fill", "#fff")
          .style("cursor", "pointer")
          .on("mouseover", function(d, i) {
            return tooltip.style("visibility", "visible").text(d.data.name);
          })
          .on("mousemove", function(d, i) {
            return tooltip
              .style("top", event.pageY - 20 + "px")
              .style("left", event.pageX + 10 + "px");
          })
          .on("mouseout", function(d, i) {
            return tooltip.style("visibility", "hidden");
          })

          .text(function(d) {
            if (d.data.name.length > 9) {
              return d.data.name.substring(0, 10) + "...";
            }
            return d.data.name;
          });

        nodeEnter
          .append("text")
          .attr("dy", 15.5)
          .attr("dx", 40)
          .style("font-size", "18px")
          .style("fill", "#fff")
          .text(function(d) {
            if (!d.data.tap) {
              return "持股" + "(" + d.data.ratio + ")";
            }
          });
        nodeEnter
          .append("text")
          .attr("dy", 5.5)
          .attr("dx", 240)
          .style("font-size", "14px")
          .style("fill", "#359FFB")
          .text(function(d) {
            if (!d.data.tap) {
              return "企业信息";
            }
          });
        var circle = nodeEnter
          .append("g")
          .on("click", click)
          .attr("class", "circle")
          .style("cursor", "pointer");

        circle
          .append("circle")
          .style("fill", "#fff")
          .style("stroke", "#D9D8D8")
          .style("stroke-width", 1)
          .attr("r", function(d) {
            if (d.children) {
              return 8.5;
            } else if (d._children) {
              return 8.5;
            } else {
              return;
            }
          })

          // .style('stroke-opacity', 1)
          .attr("transform", function(d) {
            return "translate(20,0)";
          });

        // circle.append("text")
        //     .attr("class", "sign")
        //     .attr("cx", "20px")
        //     .attr("cy", ".1.8em")
        //     .style('font-size', 18)
        //     .style('fill', function (d) {
        //         return "#D9D8D8 ";
        //     })

        //     .attr('text-anchor', 'middle')
        //     .attr('dy', '.28em')
        //     .text(function (d) {
        // 		if (d.children) {
        // 			return '-';
        // 		} else if (d._children) {
        // 			return '+';
        // 		} else {
        // 			return '';
        // 		}
        //     })
        //     .attr("transform", function (d) {
        //         return "translate(20,0)";
        //     })
        circle
          .append("text")
          .attr("dy", 4.5)
          .attr("cx", "20px")
          .attr("cy", "30px")
          .attr("font-family", "FontAwesome")
          .attr("font-size", "18")
          .attr("text-anchor", "middle")
          .attr("class", "fa")
          .style("fill", function(d) {
            return "#000 ";
          })
          .attr("transform", function(d) {
            return "translate(20,0)";
          })
          .text(function(d) {
            if (d.children) {
              return "-";
            } else if (d._children) {
              return "+";
            } else {
              return "";
            }
          });
        node.select(".fa").text(function(d) {
          if (d.children) {
            return "-";
          } else if (d._children) {
            return "+";
          } else {
            return "";
          }
        });

        //Transition nodes to their new position.
        nodeEnter
          .transition()
          .duration(duration)
          .attr("transform", function(d) {
            return "translate(" + d.y + "," + d.x + ")";
          })
          .style("opacity", 1);

        node
          .transition()
          .duration(duration)
          .attr("transform", function(d) {
            return "translate(" + d.y + "," + d.x + ")";
          })
          .style("opacity", 1)
          .select("rect")
          .style("stroke", "#666")
          .style("fill", color);

        // Transition exiting nodes to the parent's new position.
        node
          .exit()
          .transition()
          .duration(duration)
          .attr("transform", function(d) {
            return "translate(" + source.y + "," + source.x + ")";
          })
          .style("opacity", 0)
          .remove();

        //Update the links…
        var link = container.selectAll(".link").data(root.links(), function(d) {
          return d.target.id;
        });

        //Enter any new links at the parent's previous position.
        link
          .enter()
          .insert("path", "g")
          .attr("class", function(d) {
            return "link link_" + d.target.depth + " " + getClass(d.target);
          })
          .attr("d", function(d) {
            var o = { x: source.x0, y: source.y0 };
            return elbow({ source: o, target: o });
          })
          .transition()
          .duration(duration)
          .attr("d", elbow);

        //Transition links to their new position.
        link
          .transition()
          .duration(duration)
          .attr("d", elbow);

        //Transition exiting nodes to the parent's new position.
        link
          .exit()
          .transition()
          .duration(duration)
          .attr("d", function(d) {
            var o = { x: source.x, y: source.y };
            return elbow({ source: o, target: o });
          })
          .remove();

        //Stash the old positions for transition.
        root.each(function(d) {
          d.x0 = d.x;
          d.y0 = d.y;
        });
      }

      /*Toggle children on click.
	function click(d) {
		if (d.children) {
			d._children = d.children;
			d.children = null;
		} else {
			d.children = d._children;
			d._children = null;
		}
		update(d);
	}*/

      // Toggle children on click.
      var lastClickD = null;
      function click(d) {
        if (d.children) {
          d._children = d.children;
          d.children = null;
        } else {
          d.children = d._children;
          d._children = null;
        }
        if (lastClickD) {
          lastClickD._isSelected = false;
        }
        d._isSelected = true;
        lastClickD = d;
        update(d);
      }

      function getClass(d) {
        if (d.data.class) {
          return d.data.class;
        } else {
          return "";
        }
      }
      function elbow(d) {
        return (
          "M" +
          d.source.y +
          "," +
          d.source.x +
          "H" +
          (d.source.y + (d.target.y - d.source.y) / 2) +
          "V" +
          d.target.x +
          "H" +
          d.target.y
        );
      }
      function color(d) {
        if (d._isSelected) return "rgb(18, 107, 193)";
        return d._children
          ? "rgb(18, 107, 193)"
          : d.children
          ? "rgb(18, 107, 193)"
          : "rgb(18, 107, 193)";
      }
    }
  }
};
</script>

<style  lang='less'>
.gqjgtWrap {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}
.btnBox {
  position: absolute;
  top: 20px;
  left: 20px;
}
.body {
  font-family: sans-serif;
  width: 100%;
  height: 100%;
  overflow: hidden;
  margin: 0;
  padding: 0;
}
.link {
  fill: none;
  stroke: #666;
  stroke-width: 0.5px;
}
</style>


// WEBPACK FOOTER //
// src/components/gqjgt.vue